const payLaterOptions = [
    { label: 'Klarna' , value: 'klarna' },
    { label: 'After Pay', value: 'afterpay' },
  ]
  
  export default payLaterOptions;